/**
 * Asynchronously loads the component for PiecripInstitutionalPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripInstitutionalPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripInstitutionalPage
);
